"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODAL_IDS = exports.typeConversion = exports.FAULT_RING_BUFFER_DATA_TYPES = exports.FAULT_EVENT_DETAIL_HEADER_TITLES = exports.FAULT_CODES = exports.FAULT_CODE_TITLES = void 0;
var FAULT_CODE_TITLES;
(function (FAULT_CODE_TITLES) {
    FAULT_CODE_TITLES["SN"] = "Service Now";
    FAULT_CODE_TITLES["SS"] = "Service Soon";
    FAULT_CODE_TITLES["SI"] = "Service Info";
    FAULT_CODE_TITLES["SU"] = "Unknown";
    FAULT_CODE_TITLES["SP"] = "Service Preventive Maintenance";
})(FAULT_CODE_TITLES = exports.FAULT_CODE_TITLES || (exports.FAULT_CODE_TITLES = {}));
var FAULT_CODES;
(function (FAULT_CODES) {
    FAULT_CODES["SN"] = "SN";
    FAULT_CODES["SS"] = "SS";
    FAULT_CODES["SU"] = "SU";
    FAULT_CODES["SI"] = "SI";
    FAULT_CODES["SP"] = "SP";
})(FAULT_CODES = exports.FAULT_CODES || (exports.FAULT_CODES = {}));
var FAULT_EVENT_DETAIL_HEADER_TITLES;
(function (FAULT_EVENT_DETAIL_HEADER_TITLES) {
    FAULT_EVENT_DETAIL_HEADER_TITLES["ACTUAL_TORQUE"] = "Actual Torque";
    FAULT_EVENT_DETAIL_HEADER_TITLES["BATTERY_VOLTAGE"] = "Battery Voltage";
    FAULT_EVENT_DETAIL_HEADER_TITLES["ENGINE_LOAD"] = "Engine Load";
    FAULT_EVENT_DETAIL_HEADER_TITLES["ENGINE_SPEED"] = "Engine Speed";
    FAULT_EVENT_DETAIL_HEADER_TITLES["ODOMETER"] = "Odometer";
    FAULT_EVENT_DETAIL_HEADER_TITLES["VEHICLE_SPEED"] = "Vehicle Speed";
})(FAULT_EVENT_DETAIL_HEADER_TITLES = exports.FAULT_EVENT_DETAIL_HEADER_TITLES || (exports.FAULT_EVENT_DETAIL_HEADER_TITLES = {}));
var FAULT_RING_BUFFER_DATA_TYPES;
(function (FAULT_RING_BUFFER_DATA_TYPES) {
    FAULT_RING_BUFFER_DATA_TYPES["ACTUAL_TORQUE"] = "0:61444:16";
    FAULT_RING_BUFFER_DATA_TYPES["BATTERY_VOLTAGE"] = "0:65271:48";
    FAULT_RING_BUFFER_DATA_TYPES["ENGINE_LOAD"] = "0:61444:56";
    FAULT_RING_BUFFER_DATA_TYPES["ENGINE_SPEED"] = "0:61444:24";
    FAULT_RING_BUFFER_DATA_TYPES["VEHICLE_SPEED"] = "0:65265:8";
})(FAULT_RING_BUFFER_DATA_TYPES = exports.FAULT_RING_BUFFER_DATA_TYPES || (exports.FAULT_RING_BUFFER_DATA_TYPES = {}));
exports.typeConversion = {
    SI: 'serviceInfo',
    SS: 'serviceSoon',
    SN: 'serviceNow',
    SP: 'servicePM',
};
var MODAL_IDS;
(function (MODAL_IDS) {
    MODAL_IDS["NONE"] = "NONE";
    MODAL_IDS["ERROR"] = "ERROR";
    MODAL_IDS["MANAGE_USERS_ADD_USER"] = "MANAGE_USERS_ADD_USER";
    MODAL_IDS["FAULTS_CONFIRM_REQUEST_TOGGLE_IS_RESOLVED"] = "FAULTS_CONFIRM_REQUEST_TOGGLE_IS_RESOLVED";
    MODAL_IDS["FAULTS_SPECIAL_INSTRUCTIONS"] = "FAULTS_SPECIAL_INSTRUCTIONS";
    MODAL_IDS["COMMENTS_SHARE"] = "COMMENTS_SHARE";
    MODAL_IDS["DELETE_ACCOUNT"] = "DELETE_ACCOUNT";
    MODAL_IDS["MAINTENANCE_SYSTEM"] = "MAINTENANCE_SYSTEM";
    MODAL_IDS["MANAGE_SCORE_CARD"] = "MANAGE_SCORE_CARD";
    MODAL_IDS["SETTINGS_REGISTRATION"] = "SETTINGS_REGISTRATION";
    MODAL_IDS["UPLOAD_DATA_MODAL"] = "UPLOAD_DATA_MODAL";
    MODAL_IDS["UPLOAD_CUSTOM_TAGS_MODAL"] = "UPLOAD_CUSTOM_TAGS_MODAL";
    MODAL_IDS["SEARCH_VEHICLES_RESULT_MODAL"] = "SEARCH_VEHICLES_RESULT_MODAL";
    MODAL_IDS["VEHICLE_CONTACT_REMOVE_MODAL"] = "VEHICLE_CONTACT_REMOVE_MODAL";
    MODAL_IDS["VEHICLE_CONTACT_LEAVE_CONFIRM_MODAL"] = "VEHICLE_CONTACT_LEAVE_CONFIRM_MODAL";
    MODAL_IDS["CUSTOMER_SUPPORT_MODAL"] = "CUSTOMER_SUPPORT_MODAL";
    MODAL_IDS["LOCK_UNLOCK"] = "LOCK_UNLOCK";
    MODAL_IDS["SUBSCRIPTIONS_REMOVE_MODAL"] = "SUBSCRIPTIONS_REMOVE_MODAL";
})(MODAL_IDS = exports.MODAL_IDS || (exports.MODAL_IDS = {}));
exports.default = MODAL_IDS;
